var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21.75C2.82436 21.75 0.25 19.1756 0.25 16V6C0.25 2.82436 2.82436 0.25 6 0.25H16C19.1756 0.25 21.75 2.82436 21.75 6V16C21.75 19.1756 19.1756 21.75 16 21.75H6ZM13.6519 13.6514C13.9448 13.3585 13.9448 12.8837 13.6519 12.5908L12.0609 10.9998L13.6519 9.40875C13.9448 9.11586 13.9448 8.64098 13.6519 8.34809C13.359 8.05519 12.8841 8.05519 12.5912 8.34809L11.0002 9.9391L9.40924 8.34812C9.11634 8.05523 8.64147 8.05523 8.34858 8.34812C8.05568 8.64102 8.05568 9.11589 8.34858 9.40878L9.93955 10.9998L8.34858 12.5907C8.05568 12.8836 8.05568 13.3585 8.34858 13.6514C8.64147 13.9443 9.11634 13.9443 9.40924 13.6514L11.0002 12.0604L12.5912 13.6514C12.8841 13.9443 13.359 13.9443 13.6519 13.6514Z",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNew);
export default __webpack_public_path__ + "static/media/close-new.a9ef2cc5a35fdde7c61c316f20e017bd.svg";
export { ForwardRef as ReactComponent };